import React from 'react';
import { Alert } from 'reactstrap';
import styles from './index.module.scss';
import { AlertProps } from './types';

const { secondaryAlert } = styles;

export const AlertSecondary = (props: AlertProps) => <Alert data-testid={props.testId} color='secondary' className={secondaryAlert}>{props.children}</Alert>;
